import { Skeleton } from '@/components/ui/skeleton'

export function BlueprintStepSkeleton() {
  return (
    <div className="flex flex-col items-center" data-testid="blueprint-step-skeleton">
      {/* Circle Icon — real: max-width 90px, aspect-ratio 1 */}
      <Skeleton className="w-full max-w-[90px] aspect-square rounded-full" />

      {/* Progress Bar Area — real: max-width 90px, mt-[6px] */}
      <div className="w-full max-w-[90px] mt-[6px] flex flex-col gap-1">
        <Skeleton className="h-[10px] w-4 self-end rounded" />
        <Skeleton className="h-[7px] w-full rounded-[17.73px]" />
      </div>

      {/* Step label — real: mt-[6px], max-width 90px, ~11px text */}
      <Skeleton className="h-3 w-16 mt-[6px] rounded" />
    </div>
  )
}
